export default "__VITE_ASSET__DIitV8_h__"